import {
	Bar
} from "vue-chartjs";
export default {
	extends: Bar,
	props: ["data", "options", "styles"],
	mounted() {
		this.renderChart(this.data, this.options, this.styles);
	}
};


// WEBPACK FOOTER //
// ./src/views/components/xpressathon/charts.js